const addMessageTimelineActionStr = {
  toastr: 'Mensagem Adicionada'
};

export default addMessageTimelineActionStr;
